export interface GpdrData {
  accepted: boolean;
  time: Date;
}
